<div class="checkbox mb-1 w-full h-auto">
    <div class="relative w-full border" [id]="'myWidget'+captchaInstance" data-size="normal"
         [ngClass]="showCaptchaError ? 'border-red-500' : 'order-gray-#9D9D9D'"
    ></div>
    <!-- <div *ngIf="show_skeleton" class="relative w-309px h-16 animate-pulse bg-gray-300"></div> -->
</div>
